import NavbarModel from './navbar.model';

class NavbarService {
  constructor(PageService, SessionService, $timeout) {
    'ngInject';

    this.PageService = PageService;
    this.SessionService = SessionService;
    this.$timeout = $timeout;
  }

  initialize() {
    this._model = new NavbarModel();

    // Listen to changes on navigations
    this.transitionsSubscription = this.PageService.transitionEvents.subscribe((event) => {
      this.$timeout(() => {
        this.activate(event.url);
      });
    });

    // Subscribe on session.
    this.subscription = this.SessionService.session.subscribe((sessionDetails) => {
      if (sessionDetails) {
        // Set model's property when sessionDetails becomes available.
        this._model.customerName = sessionDetails.customerName;
        this._model.customerSince = sessionDetails.customerSince;
        this._model.brokerageSyncId = sessionDetails.brokerageSyncId;
        this._model.tags = sessionDetails.tags;
      }
    });    

    let ua = navigator.userAgent,
    event = (ua.match(/iP/i)) ? 'touchstart' : 'click';

    this.setUpLeftBtn(event);
    this.setUpSidebarNavigation(event);
    $.Sidemenu.highLight();

    if ($(window).width() > 768) {
      if ($('#sidebar-menu ul > li.has_sub a').hasClass('subdrop')) {
        $('#wrapper.forced').removeClass('enlarged');
      }
    }

    if ($(window).width() < 768) {
      $('#sidebar-menu>ul>li:not(.has_sub)>a, #sidebar-menu ul ul a').click(function() {
        $('#wrapper').addClass('forced enlarged');
      });
    }

    this.setActiveSubMenu();
  }

  get model() {
    return this._model;
  }

  destroy() {
    this.transitionsSubscription.unsubscribe();
    this.subscription.unsubscribe();
  }

  setUpLeftBtn(event) {
    let openLeftBtn = angular.element('.open-left');

    openLeftBtn.on(event, () => {
      $.Sidemenu.openLeftBar();
    });
  }

  setUpSidebarNavigation(event) {
    let menuItems = angular.element('#sidebar-menu a');
    
    angular.forEach(menuItems, (menuItem) => {
      angular.element(menuItem).on(event, () => {
        $.Sidemenu.menuItemClick(menuItem);
      });
    });
  }

  setActiveSubMenu() {
    $('.nav-list').on('click', 'li', function () {
      $('.nav-list li.active').removeClass('active');
      $(this).addClass('active');
    });
  }

  /**
   * Activates and opens menu items that has been clicked.
   * The navigation to be activated will be inferred from the
   * state's url path.
   *
   * E.g /transactions/deposit will activate transactions > deposit
   * nav item respectively.

    * @param {String} path - ui-sref value for the anchor tag navigation.
    */
  activate(path) {
    let navs = path.substring(1).split('/');

    // If the nav item clicked is inside a dropdown.
    if (navs.length > 1) {
      let parent = navs[0];
      let child = navs[1];
      let mainMenus = angular.element('#sidebar-menu .has_sub');
      angular.forEach(mainMenus, (menu) => {
        let menuEl = angular.element(menu);
        if (menuEl.find('.menu-parent').length === 1) {
          let menuAnchor = angular.element(menuEl.find('.menu-parent')[0]);
          let spanLabel = menuAnchor.find('span')[0].innerHTML.trim().toLowerCase();
          if (spanLabel === parent.trim()) {
            menuAnchor.addClass('subdrop');
            let siblings = menuAnchor.parent().children();
            let ul = angular.element(menuAnchor.siblings('.transact-sub')[0]);
            ul.css({ display: 'block' });

            let anchorItems = ul.find('a');
            angular.forEach(anchorItems, (item) => {
              let anchorItem = angular.element(item);
              let navLabel = anchorItem.attr('ui-sref');

              if (navLabel === child || navLabel.indexOf(child) > -1) {
                anchorItem.addClass('subdrop');
              } else {
                anchorItem.removeClass('subdrop');
              }
            });
          } else {
            menuAnchor.removeClass('subdrop');
          }
        }
      });
    } else {
      let nav = navs[0];
      let anchors = angular.element('#sidebar-menu li a');

      angular.forEach(anchors, (a) => {
        let navLabel = angular.element(a).attr('ui-sref');

        if (navLabel === nav.trim()) {
          angular.element(a).addClass('subdrop');
        } else {
          angular.element(a).removeClass('subdrop');
        }
      });
    }
  }
}

export default NavbarService;



// WEBPACK FOOTER //
// ./client/app/shared/ui/navbar/navbar.service.js